/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzResetGroupPermissionsManagedPermissionsMutationResponse, UsersAuthzResetGroupPermissionsManagedPermissionsPathParams, UsersAuthzResetGroupPermissionsManagedPermissions401, UsersAuthzResetGroupPermissionsManagedPermissions403 } from "../models/UsersAuthzResetGroupPermissionsManagedPermissions";

export function getUsersAuthzResetGroupPermissionsManagedPermissionsUrl(groupId: UsersAuthzResetGroupPermissionsManagedPermissionsPathParams["groupId"]) {
  const res = { method: 'POST', url: `/users-authz/v1/groups/${groupId}/permissions/reset` as const }
  return res
}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Reset all permissions for a group
 * {@link /users-authz/v1/groups/:groupId/permissions/reset}
 */
export async function usersAuthzResetGroupPermissionsManagedPermissions(groupId: UsersAuthzResetGroupPermissionsManagedPermissionsPathParams["groupId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<UsersAuthzResetGroupPermissionsManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetGroupPermissionsManagedPermissions401 | UsersAuthzResetGroupPermissionsManagedPermissions403>, unknown>({ method : "POST", url : getUsersAuthzResetGroupPermissionsManagedPermissionsUrl(groupId).url.toString(), ... requestConfig })
  return res.data
}